import { xs_languageCode } from '..';
import { getAggregateAllId, parseBetsData } from "./parseBetsData";
import { byRanking } from "./utils/byRanking";
import { formatDate } from './utils/formatDate';
import { getAggregationAndBetFromBetIdAndSportId } from './utils/getAggregationAndBetFromBetIdAndSportId';

export function parseBetBuilderMatchBets(match, betsContainer, parseMatchData, frontendPageType) {
	if (parseMatchData) {
		match.desc = betsContainer.dsl[xs_languageCode];
		match.matchId = betsContainer.bid;
		match.timestamp = betsContainer.ts;
		match.date = formatDate(betsContainer.ts).formatted;
		match.alias = betsContainer.al;
		const teams = match.desc.split(' - ');
		match.team1 = teams[0];
		if (teams.length > 1) {
			match.team2 = teams[1];
		}
	}

	// create a list of aggregates containing just those bets
	const aggregatesMap = {};
	const rawBets = betsContainer.scs;
	for (let kb in rawBets) {
		const bet = rawBets[kb];
		
		const allAggregations = {};
		let aggregationContainer = getAggregationAndBetFromBetIdAndSportId(match.sportRef, bet.cs, bet.h);
		if (aggregationContainer.allAggregations) {
			for (let ka in aggregationContainer.allAggregations) {
				const agg = aggregationContainer.allAggregations[ka];
				if (!agg.isLive) {
					allAggregations[agg.idAggregata] = agg;
				}
			}
		}
		if (bet.h != 0) {
			const aggregationContainerPar = getAggregationAndBetFromBetIdAndSportId(match.sportRef, bet.cs, 0);
			if (aggregationContainerPar.allAggregations) {
				for (let ka in aggregationContainerPar.allAggregations) {
					const agg = aggregationContainerPar.allAggregations[ka];
					if (!agg.isLive) {
						allAggregations[agg.idAggregata] = agg;
					}
				}
			}
		}		
		if (allAggregations) {
			for (let ka in allAggregations) {
				const key = allAggregations[ka].idAggregata;
				aggregatesMap[key] = allAggregations[ka];			
			}
		}
	}
	const aggregatesIds = [];
	for (let ka in aggregatesMap) {
		aggregatesIds.push(aggregatesMap[ka].idAggregata)
	}
	aggregatesIds.sort(byRanking);
	const allId = getAggregateAllId(match.sportRef, false);
	aggregatesIds.push(allId);
	const betsData = parseBetsData(match, aggregatesIds, allId, rawBets, false);
	if (betsData.gruppiScommessa.length > 0) {
		if (betsData.gruppiScommessa[0].idAggregata === allId && frontendPageType !== 'xsport_mobile_2') {
			const allAgg = betsData.gruppiScommessa.shift();
			betsData.gruppiScommessa.push(allAgg); // "All" aggregate must be the last one
		}
	}
	return {
        match,
        betsData,
        rawBets,
        aggregatesIds
	};
}
